import React, { useState } from "react";
import { Link } from "react-router-dom";

import User from "./admin/User";
import Area from "./admin/Area";
import Post from "./admin/Post";
import Restaurant from "./admin/Restaurant";
import Log from "./admin/Log";
import Shift   from "./admin/Shift";
import Constant   from "./admin/Constant";
import Report   from "./admin/Report";

const Admin = ({ token }) => {
  const [display, setDisplay] = useState();

  function selectModel(event, name) {
    switch (name) {
      case "user":
        setDisplay(<User token={token} />);
        break;
      case "area":
        setDisplay(<Area token={token} />);
        break;
      case "post":
        setDisplay(<Post token={token} />);
        break;
      case "restaurant":
        setDisplay(<Restaurant token={token} />);
        break;
      case "log":
        setDisplay(<Log token={token} />);
        break;
      case "Shift":
        setDisplay(<Shift token={token} />);
        break;
      case "Constant":
        setDisplay(<Constant token={token} />);
        break;
      case "Report":
        setDisplay(<Report token={token} />);
        break;
    }
  }

  return (
    <div className="container-fluid" style={{ marginTop: "5%" }}>
      <div className="row">
        <div className="col-md-2">
          <ul className="list-group">
            <li
              className="list-group-item"
              onClick={(e) => selectModel(e.stopPropagation(), "user")}
            >
              Пользователи
            </li>
            <li
              className="list-group-item"
              onClick={(e) => selectModel(e.stopPropagation(), "area")}
            >
              Области
            </li>
            <li
              className="list-group-item"
              onClick={(e) => selectModel(e.stopPropagation(), "post")}
            >
              Должности
            </li>
            <li
              className="list-group-item"
              onClick={(e) => selectModel(e.stopPropagation(), "restaurant")}
            >
              Рестораны
            </li>
            <li
              className="list-group-item"
              onClick={(e) => selectModel(e.stopPropagation(), "log")}
            >
              Логи
            </li>
            <li
              className="list-group-item"
              onClick={(e) => selectModel(e.stopPropagation(), "Shift")}
            >
              Смены
            </li>
            <li
              className="list-group-item"
              onClick={(e) => selectModel(e.stopPropagation(), "Constant")}
            >
              Константы
            </li>
            <li
              className="list-group-item"
              onClick={(e) => selectModel(e.stopPropagation(), "Report")}
            >
              Отчеты
            </li>
          </ul>
        </div>
        <div className="col-md-10">{display}</div>
      </div>
    </div>
  );
};

export default Admin;
